module.exports = __webpack_public_path__ + "img/23.da65c376.png";